import React from "react";
import CardsList from "./ClientCards/ClientCards";
import style from "./clients.module.css";

const data = {
  title: "Our Clients",
  subtitle:
    "Explore Insights Hub: Your Gateway to Resources for Elevated Success",
};
const Clients = () => {
  return (
    <section className={style.cnt}>
      <div className={style.textContainer}>
        <div className={style.titlewhy}>{data.title}</div>
        <div className={style.whysubtitle}>{data.subtitle}</div>
      </div>
      <CardsList />
    </section>
  );
};

export default Clients;
